import { ESTypes } from "../constants/constants.js";
import { getDevicePixelRatio } from "./getDevicePixelRatio.js";
const prototypeToString = (param) => {
  return Object.prototype.toString.call(param);
};
const getSize = (size, devicePixelRatio) => {
  if (prototypeToString(size) !== ESTypes.number || size < 0)
    return 0;
  const MINDEVICEPIXELRATIO = 1;
  const _devicePixelRatio = !devicePixelRatio || devicePixelRatio < MINDEVICEPIXELRATIO ? getDevicePixelRatio() : devicePixelRatio;
  return Math.floor(size * _devicePixelRatio);
};
export {
  getSize,
  prototypeToString
};
//# sourceMappingURL=tools.js.map
